import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";

import { CitizenContext } from "components/citizen/CitizenContext";
import { findDivisionById } from "services/DivisionService";
import { Button } from "primereact/button";

export const CitizenEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["citizen", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const citizenContext = useContext(CitizenContext);
    const { citizen, setCitizen, citizenDialog, setCitizenDialog } = citizenContext;

    const [permanentAddress, setPermanentAddress] = useState(null);

    useEffect(() => {
        if (citizen) {
            let provincePromise = findDivisionById(headers, citizen?.provinceId);
            let districtPromise = findDivisionById(headers, citizen?.districtId);
            let wardPromise = findDivisionById(headers, citizen?.wardId);

            Promise.all([provincePromise, districtPromise, wardPromise]).then((values) => {
                const province = values[0]?.data?.name;
                const district = values[1]?.data?.name;
                const ward = values[2]?.data?.name;

                setPermanentAddress(`${citizen.addressLine}, ${ward}, ${district}, ${province}`);
            });
        }
    }, [citizen]);

    const genders = [
        { label: t("male", { ns: "common" }), value: "1" },
        { label: t("female", { ns: "common" }), value: "0" },
    ];

    const states = [
        { label: t("unverified"), value: "UNVERIFIED" },
        { label: t("verified"), value: "VERIFIED" },
        { label: t("failed"), value: "FAILED" },
    ];

    const hideDialog = () => {
        setCitizenDialog(false);
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={citizenDialog} style={{ width: "70%" }} header={t("citizen.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* số cccd */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="idNumber">{t("idNumber")}</label>
                                    <InputText id="idNumber" value={citizen?.idNumber} readOnly />
                                </div>
                                {/* số điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="phoneNumber">{t("phoneNumber")}</label>
                                    <InputText id="phoneNumber" value={citizen?.phoneNumber} readOnly />
                                </div>
                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="state">{t("state")}</label>
                                    <InputText id="state" value={states.find((g) => g.value === citizen?.state)?.label} readOnly />
                                </div>
                            </div>

                            <div className="grid">
                                {/* họ và tên */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="fullName">{t("fullName")}</label>
                                    <InputText id="fullName" value={citizen?.fullName} readOnly />
                                </div>
                                {/* ngày sinh */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="birthdate">{t("birthdate")}</label>
                                    <InputText id="birthdate" value={citizen?.birthdate} readOnly />
                                </div>
                                {/* giới tính */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="gender">{t("gender")}</label>
                                    <InputText id="gender" value={genders.find((g) => g.value === `${citizen?.gender}`)?.label} readOnly />
                                </div>
                            </div>

                            <div className="grid">
                                {/* địa chỉ thường trú */}
                                <div className="field col-12">
                                    <label htmlFor="permanentAddress">{t("permanentAddress")}</label>
                                    <InputTextarea id="permanentAddress" value={permanentAddress} readOnly rows={3} cols={20} />
                                </div>
                            </div>

                            <div className="grid">
                                {/* người tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdBy">{t("createdBy", { ns: "common" })}</label>
                                    <InputText id="createdBy" value={citizen?.createdBy?.username} readOnly />
                                </div>
                                {/* ngày tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("createdDate", { ns: "common" })}</label>
                                    <InputText id="createdDate" value={citizen?.createdDate} readOnly />
                                </div>
                                {/* người sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedBy">{t("modifiedBy", { ns: "common" })}</label>
                                    <InputText id="modifiedBy" value={citizen?.modifiedBy?.username} readOnly />
                                </div>
                                {/* ngày sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedDate">{t("modifiedDate", { ns: "common" })}</label>
                                    <InputText id="modifiedDate" value={citizen?.modifiedDate} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
